import * as Yup from 'yup';

const Validator = (toBeValue: number) =>
  Yup.object().shape({
    numberOfRatedItems: Yup.number().oneOf([toBeValue]),
  });

export default Validator;
